module.exports = __webpack_public_path__ + "static/organicteethers-3cf51a8a2bdfb9c8aa0a08651b7d7d83.png";